<template>
  <div class="login" @keypress.enter='login'>
    <img src="/img/logo.png" alt="">
    <form class="login__main"> 
      <input 
        type='text' name='login_user' placeholder='ログインID' 
        v-model='username' @change='errorReset'
      />
      <input 
        type='password' name='password' placeholder='パスワード' 
        v-model='password' @change='errorReset'
      />
      <p class='error' v-if='error'>{{error}}</p>
      <div>
        <button class='btn' type='button'
          @click='login' :disabled='loggingin || !okToSubmit'>
          ログイン
        </button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data: function() {
    return {
      username: null,
      password: null,
      loggingin: false,
      error: '',
    }
  },
  computed: {
    okToSubmit: function() {
      return this.username && this.password;
    }
  },
  methods: {
    errorReset() {
      if (this.error) this.error = '';
    },
    login: function() {
      this.loggingin = true;
      this.$api
      .login(this.username, this.password)
      .then(()=>{
        this.loggingin = false;
      })
      .catch(()=>{
        this.loggingin = false;
      })
    },
  },
  mounted: function() {
    this.$$.context({
      title: 'ログイン',
      previous: '',
      showAccountControl: false
    })
  } 
}
</script>

<style lang='scss'>
.login {
  font-size: 1em;
  text-align: center;
  padding-top: 120px;
  padding: 6em 1em 1em;
  img {
    max-width: 100%;
    width: 280px;
    height: auto;
    display: block;
    margin: 0 auto 32px;
  }
  input {margin-bottom: 16px;}
  &__main {
    width: 240px;
    margin: auto;
  }
  .btn {
    margin-top: 16px;
  }
  .error {
    color: #ff2d2d
  }
  .version {
    font-size: 0.8em;
    color: #888888;
    margin-top: 10px;
  }
}
</style>